import React, { useState, useRef, useEffect } from 'react'
import './ClientProfile.css'
import { useAuth } from '../../Auth';
import { Link } from 'react-router-dom';

// Icons
import { FaDiamond } from "react-icons/fa6";

import { AssociateIconWithApp } from './ClientProfile';

type ClientProfilePopUpProps = {
    onClose: () => void;
    // add any other props here
};


const ClientProfilePopUp: React.FC<ClientProfilePopUpProps> = ({ onClose }) => {

    const [popUpContent, setPopUpContent] = useState(0);
    const popupContentRef = useRef<HTMLDivElement>(null);
    const [planType, setPlanType] = useState(0);
    const { plan, organization_permissions, first_name, last_name, email } = useAuth();

    // Ensuring that I always go back to the top of the popup when opening a new one
    useEffect(() => {
        if (popupContentRef.current) {
            popupContentRef.current.scrollTop = 0;
        }
    }, [popUpContent]);

    const renderPlanDetails = (plan: string) => {
        switch (plan) {
            case "Pro":
                return (
                    <>
                        <h3 style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                            <FaDiamond className='profile-plan-icons' style={{ color: '#ff9a01' }} /> Pro Plan
                        </h3>
                        <ul>
                            <li>• Scheduled HRL™ alerts delivered via email.</li>
                            <li>• 24-hour HRL™ activity delivered once daily.</li>
                            <li>• Enhanced support with guaranteed 24-hour response.</li>
                            <li>• Access to FNN™ | Esri Dashboard for advanced real-time HRL™ monitoring.</li>
                            <li>• Access to Product Suite tools including Email Dispatch and ForeFlight.</li>
                        </ul>
                    </>
                );
            case "Enterprise":
                return (
                    <>
                        <h3 style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                            <FaDiamond className='profile-plan-icons' style={{ color: '#ffd901' }} /> Enterprise Plan
                        </h3>
                        <ul>
                            <li>• Scheduled HRL™ alerts delivered via email.</li>
                            <li>• 24-hour HRL™ activity delivered once daily.</li>
                            <li>• Priority 24/7 dedicated support.</li>
                            <li>• Multi-account access to FNN™ | Esri HRL Dashboard for advanced real-time HRL™ monitoring.</li>
                            <li>• Advanced access to Product Suite Applications</li>
                        </ul>
                    </>
                );
            case "Starter":
            default:
                return (
                    <>
                        <h3 style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                            <FaDiamond className='profile-plan-icons' /> Starter Plan
                        </h3>
                        <ul>
                            <li>• Scheduled HRL™ alerts delivered via email.</li>
                            <li>• 24-hour HRL™ activity delivered once daily.</li>
                            <li>• Reliable standard support with 48-hour response.</li>
                            <li>• Access to Product Suite tools including Email Dispatch and ForeFlight.</li>
                        </ul>
                    </>
                );
        }
    };

    const planLevels = { Starter: 0, Pro: 1, Enterprise: 2 };
    const levelToPlan = ["Starter", "Pro", "Enterprise"];

    type PlanName = keyof typeof planLevels;

    const getPlanButtonLabel = (userPlan: string, cardPlan: string) => {
        if (!(userPlan in planLevels) || !(cardPlan in planLevels)) return 'Unknown';
        if (userPlan === cardPlan) return 'Current Plan';

        const userLevel = planLevels[userPlan as PlanName];
        const cardLevel = planLevels[cardPlan as PlanName];

        return cardLevel > userLevel ? 'Upgrade' : 'Downgrade';
    };




    return (
        <div className="popup-overlay">
            <div className="popup-content" ref={popupContentRef}>

                {popUpContent === 0 &&
                    <div className='plan-popup-wrapper'>

                        <div className='plan-title-and-back-button' style={{ justifyContent: 'space-between' }}>
                            <h1>Manage Plan</h1>
                            <div className='pop-adjust-buttons' style={{ textDecoration: 'none', color: 'black' }} onClick={onClose} >
                                <button style={{ paddingLeft: '1rem', paddingRight: '1rem' }}><strong>Back</strong></button>
                            </div>
                        </div>

                        <div className='both-sides-plan'>

                            <div className='left-side-plan'>
                                <h2><strong> Your Plan</strong></h2>
                                {renderPlanDetails(plan)}
                            </div>


                            <div className='right-side-plan'>
                                <h2><strong> Your Options</strong></h2>

                                <div className='plan-options-and-button'>
                                    <div>
                                        <h4><strong> Change your Plan</strong></h4>
                                        <p>Compare available plans and upgrade to unlock enhanced High-Risk Lightning™
                                            data, extended insights, and advanced platform features tailored to your needs.</p>
                                    </div>

                                    <div><button className='account-button options-button-addon' onClick={() => setPopUpContent(1)}> Explore</button></div>
                                </div>

                                <div className='plan-options-and-button'>
                                    <div>
                                        <h4><strong> Interested in Customization?</strong></h4>
                                        <p>Looking for a tailored plan? Contact our team to create a custom plan that fits your
                                            specific High-Risk Lightning™ monitoring and data integration needs.</p>
                                    </div>

                                    <Link to='/fnn_portal_representative'><button className='account-button options-button-addon'> Contact Us</button></Link>
                                </div>

                            </div>

                        </div>



                    </div>
                }

                {popUpContent === 1 &&
                    <div className='plan-popup-wrapper'>
                        <div className='plan-title-and-back-button' style={{ justifyContent: 'flex-end' }}>
                            <h1 className='multi-plans-title'>Available Plans</h1>
                            <div className='pop-adjust-buttons' style={{ textDecoration: 'none', color: 'black' }} onClick={() => setPopUpContent(0)} >
                                <button style={{ paddingLeft: '1rem', paddingRight: '1rem' }}><strong>Back</strong></button>
                            </div>
                        </div>

                        <div className='plans-card-stack'>

                            <div className='plans-card'>

                                <div className='plan-card-top'>
                                    <FaDiamond className='profile-plan-icons' />
                                    <h1>Starter Plan</h1>

                                </div>

                                <div className='plan-card-bottom'>

                                    <div className='card-sub-title-and-options'>
                                        <h1>Begin Monitoring HRL™ Today</h1>

                                        <ul>
                                            <li><div>•</div> Scheduled HRL™ alerts delivered via email.</li>
                                            <li><div>•</div> 24-hour HRL™ activity delivered once daily.</li>
                                            <li><div>•</div> Reliable standard support with 48-hour response.</li>
                                            <li><div>•</div> Access to Product Suite tools including Email Dispatch and ForeFlight.</li>
                                        </ul>
                                    </div>

                                    <div>
                                        <button
                                            className='account-button options-button-addon'
                                            onClick={() => (setPopUpContent(2), setPlanType(0))}
                                        >
                                            {getPlanButtonLabel(plan, 'Starter')}
                                        </button>
                                    </div>

                                </div>



                            </div>

                            <div className='plans-card'>

                                <div className='plan-card-top'>
                                    <FaDiamond className='profile-plan-icons' style={{ color: '#ff9a01' }} />
                                    <h1>Pro Plan</h1>

                                </div>

                                <div className='plan-card-bottom'>

                                    <div className='card-sub-title-and-options'>
                                        <h1>Take Your Lightning Insights Further</h1>

                                        <ul>
                                            <li><div>•</div> Scheduled HRL™ alerts delivered via email.</li>
                                            <li><div>•</div>24-hour HRL™ activity delivered once daily.</li>
                                            <li><div>•</div> Enhanced support with guaranteed 24-hour response.</li>
                                            <li> <div>•</div> Access to FNN™ | Esri Dashboard for advanced real-time HRL™ monitoring.</li>
                                            <li><div>•</div>Access to Product Suite tools including Email Dispatch and ForeFlight.</li>
                                        </ul>
                                    </div>

                                    <div>
                                        <button
                                            className='account-button options-button-addon'
                                            onClick={() => (setPopUpContent(2), setPlanType(1))}
                                        >
                                            {getPlanButtonLabel(plan, 'Pro')}
                                        </button>
                                    </div>

                                </div>



                            </div>

                            <div className='plans-card'>

                                <div className='plan-card-top'>
                                    <FaDiamond className='profile-plan-icons' style={{ color: '#ffd901' }} />
                                    <h1>Enterprise Plan</h1>

                                </div>

                                <div className='plan-card-bottom'>

                                    <div className='card-sub-title-and-options'>
                                        <h1>Unlock Full Potential of HRL™ Insights</h1>

                                        <ul>
                                            <li><div>•</div> Scheduled HRL™ alerts delivered via email.</li>
                                            <li><div>•</div> 24-hour HRL™ activity delivered once daily.</li>
                                            <li><div>•</div> Priority 24/7 dedicated support.</li>
                                            <li><div>•</div> Multi-account access to FNN™ | Esri HRL Dashboard for advanced real-time HRL™ monitoring.</li>
                                            <li><div>•</div> Advanced access to Product Suite Applications</li>
                                        </ul>
                                    </div>

                                    <div>
                                        <button
                                            className='account-button options-button-addon'
                                            onClick={() => (setPopUpContent(2), setPlanType(2))}
                                        >
                                            {getPlanButtonLabel(plan, 'Enterprise')}
                                        </button>
                                    </div>

                                </div>



                            </div>

                        </div>
                    </div>
                }

                {popUpContent === 2 &&
                    <div className='benefits-wrapper'>

                        {/* Plan title */}
                        <div className='benefits-top'>
                            <FaDiamond className='profile-plan-icons' style={planType === 1 ? { color: '#ff9a01' } : planType === 2 ? { color: '#ffd901' } : {}} />
                            <h1>{['Starter Plan', 'Pro Plan', 'Enterprise Plan'][planType]}</h1>
                        </div>

                        <div className="benefits-content">
                            <h2 className='benefits-h2'><strong>Benefits</strong></h2>
                            <div className='plan-extension'>
                                {
                                    levelToPlan[planType] === plan
                                        ? organization_permissions?.map((perm, index) =>
                                            <React.Fragment key={index}>
                                                {AssociateIconWithApp(perm, 'profile-menu-icons2')}
                                            </React.Fragment>
                                        )
                                        : <>
                                            {AssociateIconWithApp("Email Dispatch", 'profile-menu-icons2')}
                                            {AssociateIconWithApp("ForeFlight", 'profile-menu-icons2')}
                                            {AssociateIconWithApp("FNN Contact", 'profile-menu-icons2')}


                                            {planType === 1 &&
                                                <>
                                                    {AssociateIconWithApp("Esri Dashboard", 'profile-menu-icons2')}
                                                    {AssociateIconWithApp("Tutorial Videos", 'profile-menu-icons2')}
                                                </>
                                            }

                                            {planType === 2 &&
                                                <>
                                                    {AssociateIconWithApp("Esri Dashboard", 'profile-menu-icons2')}
                                                    {AssociateIconWithApp("Tutorial Videos", 'profile-menu-icons2')}
                                                    {AssociateIconWithApp("Advanced Product Suite", 'profile-menu-icons2')}
                                                </>
                                            }
                                        </>
                                }
                            </div>
                        </div>


                        <div className='plan-extension-buttons'>
                            <div>
                                <button className='account-button extension-addon' onClick={() => setPopUpContent(1)}>
                                    Cancel
                                </button>
                            </div>

                            {levelToPlan[planType] !== plan && (
                                <div>
                                    <button
                                        className='account-button extension-addon'
                                        onClick={async () => {
                                            const res = await fetch('/portal/api/send-brevo-email/', {
                                                method: 'POST',
                                                headers: { 'Content-Type': 'application/json' },
                                                body: JSON.stringify({
                                                    planType: levelToPlan[planType],
                                                    userPlan: plan,
                                                    firstName: first_name,
                                                    lastName: last_name,
                                                    email: email,
                                                    isEmail1: true,
                                                }),
                                            });

                                            if (res.ok) {
                                                setPopUpContent(3);
                                            } else {
                                                const data = await res.json();
                                                console.error('Failed to send email:', data);
                                                alert('There was a problem sending your request.');
                                            }
                                        }}
                                    >
                                        Select Plan
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                }

                {popUpContent === 3 &&
                    <div className='plan-almost-there-overall-wrapper'>
                        <div className='plan-almost-there-wrapper'>
                            <h1><strong>Almost There!</strong></h1>
                            <p>You’re one step closer to unlocking the power of High-Risk Lightning™ data.</p>
                        </div>

                        <div className='whats-next-wrapper'>
                            <h1>What’s next</h1>
                            <p>
                                An email has been sent to an FNN™ representative with your request. A team
                                <span className="responsive-br"><br /> </span>
                                {" "} member will reach out shortly to finalize the details and help get you started.
                            </p>


                        </div>

                        <div className='account-button-wrapper-div'>
                            <button className="plan-my-account-button" onClick={onClose}>
                                My Account
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </button>

                        </div>






                    </div>
                }

            </div>
        </div>
    )
}

export default ClientProfilePopUp